import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function FragmentIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "12"}
      height={height || "9.599"}
      viewBox="0 0 12 9.599"
    >
      <path
        id="Path_10416"
        data-name="Path 10416"
        d="M-6.021-6.159a.225.225,0,0,0,.279-.154l2.559-8.816a.225.225,0,0,0-.154-.279L-4.48-15.74a.225.225,0,0,0-.279.154L-7.319-6.771a.225.225,0,0,0,.154.279Zm-2.137-2.1.816-.87a.225.225,0,0,0-.015-.322l-1.7-1.494,1.7-1.494a.223.223,0,0,0,.015-.322l-.816-.87a.225.225,0,0,0-.319-.009l-2.7,2.531a.224.224,0,0,0,0,.328l2.7,2.533A.224.224,0,0,0-8.159-8.263Zm6.135.011,2.7-2.533a.224.224,0,0,0,0-.328l-2.7-2.535a.227.227,0,0,0-.319.009l-.816.87a.225.225,0,0,0,.015.322l1.7,1.5-1.7,1.494a.223.223,0,0,0-.015.322l.816.87A.225.225,0,0,0-2.024-8.252Z"
        transform="translate(11.251 15.749)"
        fill={color || "#707070"}
      />
    </svg>
  );
}
